import { M8DemoStackDTO, M8UserProfile } from 'services/production/types';
import { DemoStackInfo, TDashboardDemoStackInfo } from 'types/state';

export const normalizeM8DemoStackInfo = (info: M8DemoStackDTO) => ({
  toDashboardDemoStackInfo(user: M8UserProfile): TDashboardDemoStackInfo {
    return {
      email: user.email || '',
      url: info.url || 'undefined',
      dnsName: info.dnsName || '',
    };
  },
  toDemoStackInfo(): DemoStackInfo {
    return {
      id: info.id,
      originURL: info.url,
      subdomain: info.dnsName,
      loginURL: info.linkLogin,
    };
  },
});
